/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseConversation } from '../models/api-response-conversation';
import { ApiResponseConversationMessages } from '../models/api-response-conversation-messages';
import { ApiResponseListConversationMessageDto } from '../models/api-response-list-conversation-message-dto';
import { ApiResponsePagedResultConversationItemList } from '../models/api-response-paged-result-conversation-item-list';
import { existingConversationOfContact } from '../fn/conversation-api/existing-conversation-of-contact';
import { ExistingConversationOfContact$Params } from '../fn/conversation-api/existing-conversation-of-contact';
import { exportAllConversation } from '../fn/conversation-api/export-all-conversation';
import { ExportAllConversation$Params } from '../fn/conversation-api/export-all-conversation';
import { exportConversation } from '../fn/conversation-api/export-conversation';
import { ExportConversation$Params } from '../fn/conversation-api/export-conversation';
import { globalPoolingTeamInbox } from '../fn/conversation-api/global-pooling-team-inbox';
import { GlobalPoolingTeamInbox$Params } from '../fn/conversation-api/global-pooling-team-inbox';
import { listConversationsOfCompanyNumber } from '../fn/conversation-api/list-conversations-of-company-number';
import { ListConversationsOfCompanyNumber$Params } from '../fn/conversation-api/list-conversations-of-company-number';
import { manageConversationTags } from '../fn/conversation-api/manage-conversation-tags';
import { ManageConversationTags$Params } from '../fn/conversation-api/manage-conversation-tags';
import { patchFavoriteConversation } from '../fn/conversation-api/patch-favorite-conversation';
import { PatchFavoriteConversation$Params } from '../fn/conversation-api/patch-favorite-conversation';
import { patchSeenConversation } from '../fn/conversation-api/patch-seen-conversation';
import { PatchSeenConversation$Params } from '../fn/conversation-api/patch-seen-conversation';
import { showAgentTyping } from '../fn/conversation-api/show-agent-typing';
import { ShowAgentTyping$Params } from '../fn/conversation-api/show-agent-typing';
import { startNewConversation } from '../fn/conversation-api/start-new-conversation';
import { StartNewConversation$Params } from '../fn/conversation-api/start-new-conversation';
import { startNewConversationWithMedia } from '../fn/conversation-api/start-new-conversation-with-media';
import { StartNewConversationWithMedia$Params } from '../fn/conversation-api/start-new-conversation-with-media';
import { TeamInboxPoolingState } from '../models/team-inbox-pooling-state';

@Injectable({ providedIn: 'root' })
export class ConversationApiService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `manageConversationTags()` */
  static readonly ManageConversationTagsPath = '/v1/api/ui/conversation/{reference}/tags';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `manageConversationTags()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  manageConversationTags$Response(params: ManageConversationTags$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversation>> {
    return manageConversationTags(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `manageConversationTags$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  manageConversationTags(params: ManageConversationTags$Params, context?: HttpContext): Observable<ApiResponseConversation> {
    return this.manageConversationTags$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseConversation>): ApiResponseConversation => r.body)
    );
  }

  /** Path part for operation `patchSeenConversation()` */
  static readonly PatchSeenConversationPath = '/v1/api/ui/conversation/{reference}/seen';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchSeenConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchSeenConversation$Response(params: PatchSeenConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchSeenConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchSeenConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchSeenConversation(params: PatchSeenConversation$Params, context?: HttpContext): Observable<void> {
    return this.patchSeenConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `showAgentTyping()` */
  static readonly ShowAgentTypingPath = '/v1/api/ui/conversation/{reference}/typing';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `showAgentTyping()` instead.
   *
   * This method doesn't expect any request body.
   */
  showAgentTyping$Response(params: ShowAgentTyping$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return showAgentTyping(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `showAgentTyping$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  showAgentTyping(params: ShowAgentTyping$Params, context?: HttpContext): Observable<void> {
    return this.showAgentTyping$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchFavoriteConversation()` */
  static readonly PatchFavoriteConversationPath = '/v1/api/ui/conversation/{reference}/favorite';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchFavoriteConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchFavoriteConversation$Response(params: PatchFavoriteConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return patchFavoriteConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchFavoriteConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patchFavoriteConversation(params: PatchFavoriteConversation$Params, context?: HttpContext): Observable<void> {
    return this.patchFavoriteConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `startNewConversation()` */
  static readonly StartNewConversationPath = '/v1/api/ui/conversation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startNewConversation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  startNewConversation$Response(params: StartNewConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversation>> {
    return startNewConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startNewConversation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  startNewConversation(params: StartNewConversation$Params, context?: HttpContext): Observable<ApiResponseConversation> {
    return this.startNewConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseConversation>): ApiResponseConversation => r.body)
    );
  }

  /** Path part for operation `startNewConversationWithMedia()` */
  static readonly StartNewConversationWithMediaPath = '/v1/api/ui/conversation/media';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `startNewConversationWithMedia()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  startNewConversationWithMedia$Response(params: StartNewConversationWithMedia$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversation>> {
    return startNewConversationWithMedia(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `startNewConversationWithMedia$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  startNewConversationWithMedia(params: StartNewConversationWithMedia$Params, context?: HttpContext): Observable<ApiResponseConversation> {
    return this.startNewConversationWithMedia$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseConversation>): ApiResponseConversation => r.body)
    );
  }

  /** Path part for operation `listConversationsOfCompanyNumber()` */
  static readonly ListConversationsOfCompanyNumberPath = '/v1/api/ui/conversation/list-of/{refPhoneCompany}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listConversationsOfCompanyNumber()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listConversationsOfCompanyNumber$Response(params: ListConversationsOfCompanyNumber$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultConversationItemList>> {
    return listConversationsOfCompanyNumber(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listConversationsOfCompanyNumber$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  listConversationsOfCompanyNumber(params: ListConversationsOfCompanyNumber$Params, context?: HttpContext): Observable<ApiResponsePagedResultConversationItemList> {
    return this.listConversationsOfCompanyNumber$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponsePagedResultConversationItemList>): ApiResponsePagedResultConversationItemList => r.body)
    );
  }

  /** Path part for operation `exportAllConversation()` */
  static readonly ExportAllConversationPath = '/v1/api/ui/conversation/export-all';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportAllConversation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportAllConversation$Response(params: ExportAllConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseListConversationMessageDto>> {
    return exportAllConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportAllConversation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  exportAllConversation(params: ExportAllConversation$Params, context?: HttpContext): Observable<ApiResponseListConversationMessageDto> {
    return this.exportAllConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseListConversationMessageDto>): ApiResponseListConversationMessageDto => r.body)
    );
  }

  /** Path part for operation `exportConversation()` */
  static readonly ExportConversationPath = '/v1/api/ui/conversation/{reference}/export';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `exportConversation()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConversation$Response(params: ExportConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversationMessages>> {
    return exportConversation(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `exportConversation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  exportConversation(params: ExportConversation$Params, context?: HttpContext): Observable<ApiResponseConversationMessages> {
    return this.exportConversation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseConversationMessages>): ApiResponseConversationMessages => r.body)
    );
  }

  /** Path part for operation `globalPoolingTeamInbox()` */
  static readonly GlobalPoolingTeamInboxPath = '/v1/api/ui/conversation/team-inbox/pooling';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `globalPoolingTeamInbox()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalPoolingTeamInbox$Response(params: GlobalPoolingTeamInbox$Params, context?: HttpContext): Observable<StrictHttpResponse<TeamInboxPoolingState>> {
    return globalPoolingTeamInbox(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `globalPoolingTeamInbox$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  globalPoolingTeamInbox(params: GlobalPoolingTeamInbox$Params, context?: HttpContext): Observable<TeamInboxPoolingState> {
    return this.globalPoolingTeamInbox$Response(params, context).pipe(
      map((r: StrictHttpResponse<TeamInboxPoolingState>): TeamInboxPoolingState => r.body)
    );
  }

  /** Path part for operation `existingConversationOfContact()` */
  static readonly ExistingConversationOfContactPath = '/v1/api/ui/conversation/existing-conversation';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `existingConversationOfContact()` instead.
   *
   * This method doesn't expect any request body.
   */
  existingConversationOfContact$Response(params: ExistingConversationOfContact$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversation>> {
    return existingConversationOfContact(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `existingConversationOfContact$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  existingConversationOfContact(params: ExistingConversationOfContact$Params, context?: HttpContext): Observable<ApiResponseConversation> {
    return this.existingConversationOfContact$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseConversation>): ApiResponseConversation => r.body)
    );
  }

}
